// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.node-picker__wrapper[data-v-cc039314]:not(:last-of-type) {
  border-bottom: 1px solid var(--color-border);
}
.node-picker[data-v-cc039314] {
  display: flex;
  align-items: center;
  height: 64px;
}
.node-picker__icon[data-v-cc039314],
.node-picker__preview[data-v-cc039314] {
  height: 64px;
  width: 64px;
  margin: 0 var(--secondary-margin);
  display: block;
  flex: 0 0 64px;
}
.node-picker__icon[data-v-cc039314] {
  color: var(--color-text-maxcontrast);
}
.node-picker__preview[data-v-cc039314] {
  overflow: hidden;
  border-radius: calc(var(--border-radius) * 2);
  background-position: center;
  background-size: cover;
}
.node-picker__desc[data-v-cc039314] {
  display: flex;
  flex-direction: column;
}
.node-picker__desc span[data-v-cc039314] {
  white-space: nowrap;
}
[data-v-9de22627] .modal-container__content {
  display: flex;
  overflow: visible;
  flex-direction: column;
}
.conflict-picker[data-v-9de22627] {
  --margin: 36px;
  --secondary-margin: 18px;
}
.conflict-picker__header[data-v-9de22627] {
  position: sticky;
  z-index: 10;
  top: 0;
  padding: var(--margin);
  padding-bottom: 0;
}
.conflict-picker__form[data-v-9de22627] {
  position: relative;
  overflow: auto;
  padding: 0 var(--margin);
  padding-bottom: 12px;
  margin-bottom: -12px;
}
.conflict-picker fieldset[data-v-9de22627] {
  display: grid;
  width: 100%;
  margin-top: calc(var(--secondary-margin) * 1.5);
  padding-bottom: var(--secondary-margin);
  grid-template-columns: 1fr 1fr;
}
.conflict-picker fieldset[data-v-9de22627] legend {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: calc(var(--secondary-margin) / 2);
}
.conflict-picker fieldset.conflict-picker__all[data-v-9de22627] {
  position: sticky;
  top: 0;
  margin: 0;
  padding: var(--secondary-margin) 0;
  background-image: linear-gradient(to top, transparent, var(--color-main-background-blur) 10%, var(--color-main-background) 15%);
}
.conflict-picker fieldset.conflict-picker__all + fieldset[data-v-9de22627] {
  margin-top: 0;
}
.conflict-picker fieldset.conflict-picker__all[data-v-9de22627] label {
  font-weight: 700;
}
.conflict-picker__controls[data-v-9de22627] {
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  padding: var(--secondary-margin);
  border-radius: var(--border-radius-large);
  background-image: linear-gradient(to bottom, transparent, var(--color-main-background-blur) 10%, var(--color-main-background) 15%);
}
.conflict-picker__controls button[data-v-9de22627] {
  margin-left: var(--secondary-margin);
}
.conflict-picker__controls button.button-vue--disabled[data-v-9de22627] {
  cursor: default;
  opacity: .5;
  filter: saturate(.7);
}
@media screen and (max-width: 768px) {
  .conflict-picker[data-v-9de22627] {
    --margin: var(--secondary-margin) !important;
  }
  .conflict-picker__description[data-v-9de22627] {
    display: none !important;
  }
  .conflict-picker fieldset[data-v-9de22627] {
    grid-template-columns: 1fr !important;
  }
  .conflict-picker fieldset.conflict-picker__all[data-v-9de22627] {
    position: static;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/upload/dist/assets/ConflictPicker-8e1eb7d1.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;EACX,+CAA+C;EAC/C,uCAAuC;EACvC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,kCAAkC;EAClC,+HAA+H;AACjI;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,yCAAyC;EACzC,kIAAkI;AACpI;AACA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;AACA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".node-picker__wrapper[data-v-cc039314]:not(:last-of-type) {\n  border-bottom: 1px solid var(--color-border);\n}\n.node-picker[data-v-cc039314] {\n  display: flex;\n  align-items: center;\n  height: 64px;\n}\n.node-picker__icon[data-v-cc039314],\n.node-picker__preview[data-v-cc039314] {\n  height: 64px;\n  width: 64px;\n  margin: 0 var(--secondary-margin);\n  display: block;\n  flex: 0 0 64px;\n}\n.node-picker__icon[data-v-cc039314] {\n  color: var(--color-text-maxcontrast);\n}\n.node-picker__preview[data-v-cc039314] {\n  overflow: hidden;\n  border-radius: calc(var(--border-radius) * 2);\n  background-position: center;\n  background-size: cover;\n}\n.node-picker__desc[data-v-cc039314] {\n  display: flex;\n  flex-direction: column;\n}\n.node-picker__desc span[data-v-cc039314] {\n  white-space: nowrap;\n}\n[data-v-9de22627] .modal-container__content {\n  display: flex;\n  overflow: visible;\n  flex-direction: column;\n}\n.conflict-picker[data-v-9de22627] {\n  --margin: 36px;\n  --secondary-margin: 18px;\n}\n.conflict-picker__header[data-v-9de22627] {\n  position: sticky;\n  z-index: 10;\n  top: 0;\n  padding: var(--margin);\n  padding-bottom: 0;\n}\n.conflict-picker__form[data-v-9de22627] {\n  position: relative;\n  overflow: auto;\n  padding: 0 var(--margin);\n  padding-bottom: 12px;\n  margin-bottom: -12px;\n}\n.conflict-picker fieldset[data-v-9de22627] {\n  display: grid;\n  width: 100%;\n  margin-top: calc(var(--secondary-margin) * 1.5);\n  padding-bottom: var(--secondary-margin);\n  grid-template-columns: 1fr 1fr;\n}\n.conflict-picker fieldset[data-v-9de22627] legend {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: calc(var(--secondary-margin) / 2);\n}\n.conflict-picker fieldset.conflict-picker__all[data-v-9de22627] {\n  position: sticky;\n  top: 0;\n  margin: 0;\n  padding: var(--secondary-margin) 0;\n  background-image: linear-gradient(to top, transparent, var(--color-main-background-blur) 10%, var(--color-main-background) 15%);\n}\n.conflict-picker fieldset.conflict-picker__all + fieldset[data-v-9de22627] {\n  margin-top: 0;\n}\n.conflict-picker fieldset.conflict-picker__all[data-v-9de22627] label {\n  font-weight: 700;\n}\n.conflict-picker__controls[data-v-9de22627] {\n  z-index: 10;\n  display: flex;\n  justify-content: flex-end;\n  padding: var(--secondary-margin);\n  border-radius: var(--border-radius-large);\n  background-image: linear-gradient(to bottom, transparent, var(--color-main-background-blur) 10%, var(--color-main-background) 15%);\n}\n.conflict-picker__controls button[data-v-9de22627] {\n  margin-left: var(--secondary-margin);\n}\n.conflict-picker__controls button.button-vue--disabled[data-v-9de22627] {\n  cursor: default;\n  opacity: .5;\n  filter: saturate(.7);\n}\n@media screen and (max-width: 768px) {\n  .conflict-picker[data-v-9de22627] {\n    --margin: var(--secondary-margin) !important;\n  }\n  .conflict-picker__description[data-v-9de22627] {\n    display: none !important;\n  }\n  .conflict-picker fieldset[data-v-9de22627] {\n    grid-template-columns: 1fr !important;\n  }\n  .conflict-picker fieldset.conflict-picker__all[data-v-9de22627] {\n    position: static;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
